import { Action } from '../types'

const createAction = <P, M, E> (
  type: string,
  payload?: P,
  meta?: M,
  error?: E,
): Action<string, P, M, E> => {
  const action = {
    type,
    payload,
    meta,
    error,
  }

  Object.keys(action).forEach(
    key => action[key] === undefined && delete action[key],
  )

  return action
}

export default createAction



// WEBPACK FOOTER //
// ./src/redux/redux-utils/create-action.ts